module.exports = __webpack_public_path__ + "img/191.d5a71820.jpg";